<template>
  <div
    class="focus-within:border-primary-400 relative mt-2 rounded-md border border-slate-300 px-3 py-2 shadow-xs focus-within:ring-0"
    :class="{
      'bg-gray-50': !editionMode || disabled
    }"
  >
    <BaseLabelTop
      :target="name"
      :label="label"
      :disabled="disabled"
      :required="required"
    />
    <textarea
      v-if="editionMode && !disabled"
      :id="name"
      ref="ta"
      v-model.trim="newValue"
      class="block max-h-[350px] min-h-[110px] w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
      :placeholder="placeholder"
      :name="name"
      rows="4"
      :disabled="disabled"
    />
    <span
      v-if="editionMode && !disabled"
      class="pointer-events-none absolute bottom-1 right-2 text-xs text-gray-400 select-none"
    >
      {{ (newValue || '').replace(/\s/g, '').length }}
    </span>

    <div
      v-if="!editionMode || disabled"
      class="max-h-[350px] min-h-[110px] overflow-x-hidden overflow-y-auto text-gray-900 sm:text-sm"
    >
      {{ newValue }}
    </div>

    <div
      v-for="(error, index) in errors"
      :key="index"
      class="form-help text-red-600"
    >
      {{ $t(error, { attribute: $t('attributes.' + name) }) }}
    </div>
  </div>
</template>

<script>
import BaseLabelTop from '@c/addf-package/components/BaseLabel/BaseLabelTop.vue'

export default {
  name: 'BaseTextArea',
  components: { BaseLabelTop },
  props: {
    modelValue: {
      type: [String, Number],
      required: false,
      default: null
    },
    editionMode: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    errors: {
      type: Object,
      required: false
    }
  },
  emits: ['change', 'input', 'update:model-value'],
  data() {
    return {
      newValue: this.modelValue || this.value
    }
  },
  watch: {
    newValue(newValue) {
      this.$emit('change', {
        value: newValue,
        attribute: this.name
      })

      this.$emit('input', {
        value: newValue,
        attribute: this.name
      })

      this.$emit('update:model-value', newValue)
    }
  },
  methods: {
    setTextAtPosition(text) {
      this.$refs.ta.value =
        this.$refs.ta.value.slice(0, this.$refs.ta.selectionStart) +
        text +
        this.$refs.ta.value.slice(this.$refs.ta.selectionStart)
    }
  }
}
</script>
